import React, { useEffect, useRef, useState, useMemo } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import * as S from '../../UsersStyles';
import { usePermissions } from '../../../../../hooks/usePermissions';
import makeAnimated from 'react-select/animated';
import {
  WithContext as ReactTags,
  type Tag as ReactTag,
} from 'react-tag-input';
import { toast } from 'react-toastify';

import { useClient } from '../../../../../hooks/useClient';
import { useAccess } from '../../../../../hooks';
import {
  formatDocumentCNPJ,
  sendNotification,
} from '../../../../../utils/functions';

import { FaRegCircleQuestion } from 'react-icons/fa6';
import { LoadingCircle, Tooltip } from '../../../../../components';
import { updateDealer } from '../../../../../hooks/TeamManager';

const toastConfig = {
  autoClose: 3000,
  hideProgressBar: true,
  type: 'success',
};

type AccessProfile = {
  value: number;
  label: string;
  descricao: string;
};
export const RegistrationClientForm: React.FC<{
  onCancel: () => void;
  type?: string;
  dealer?: any;
  setMenuOpen?: any;
  listPerfis?: any;
  getListDealers?: () => void;
}> = ({ onCancel, type, dealer, setMenuOpen, listPerfis, getListDealers }) => {
  const KeyCodes = {
    comma: 188,
    enter: 13,
  };
  const [loadingCnpj, setLoadingCnpj] = useState(false);
  const [typeLayout, setTypeLayout] = useState('');
  const [perfis, setperfis] = useState('');
  const cnpjContainerRef = useRef<HTMLDivElement>(null);
  const initialFormState = {
    grupoEconomico: [],
    canaisResponsaveis: [],
    emails: [],
    cnpjRaiz: [],
  };

  const initialFormStateDealer = {
    nome: '',
    email: '',
    profile: '',
  };

  useEffect(() => {
    setTypeLayout(type ?? '');
  }, [type]);

  const [formDataDealer, setFormDataDealer] = useState({
    nome: '',
    email: '',
    profile: null as any,
  });

  const arrayPerfis = [{}];

  //função de mapear os perfis original

  const accessProfiles = useMemo<AccessProfile[]>(() => {
    const profilesSource =
      listPerfis?.data?.items ?? listPerfis?.items ?? listPerfis ?? [];

    if (!Array.isArray(profilesSource)) {
      return [];
    }

    return profilesSource.map((perfil: any) => ({
      value: perfil.id,
      label: perfil.nome,
      descricao: perfil.descricao,
    }));
  }, [listPerfis]);
  useEffect(() => {
    if (!dealer) return;

    const selectedProfile =
      accessProfiles.find(profile => profile.label === dealer.perfil) ?? null;

    setFormDataDealer({
      nome: dealer.nome ?? '',
      email: dealer.email ?? '',
      profile: selectedProfile,
    });
  }, [dealer, accessProfiles]);
  useEffect(() => {
    const input = cnpjContainerRef.current?.querySelector(
      'input',
    ) as HTMLInputElement | null;
    if (!input) return;

    const nativeValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value',
    )?.set;

    const setInputValue = (value: string) => {
      nativeValueSetter?.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey) return;

      if (e.key.length > 1) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
          const clean = input.value.replace(/[./-]/g, '');
          if (clean.length === 0) return;

          e.preventDefault();
          const newClean = clean.slice(0, -1);
          setInputValue(newClean ? formatDocumentCNPJ(newClean) : '');
        }
        return;
      }

      if (!/^[A-Za-z0-9]$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      if (e.key === ',') {
        e.preventDefault();
        return;
      }

      const clean = input.value.replace(/[./-]/g, '');
      if (clean.length >= 14) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      const newClean = clean + e.key.toUpperCase();
      setInputValue(formatDocumentCNPJ(newClean));
    };

    const onPaste = (e: ClipboardEvent) => {
      e.preventDefault();
      const pasted = (e.clipboardData?.getData('text') ?? '')
        .replace(/[^A-Za-z0-9]/g, '')
        .toUpperCase()
        .slice(0, 14);

      setInputValue(formatDocumentCNPJ(pasted));
    };

    input.addEventListener('keydown', onKeyDown);
    input.addEventListener('paste', onPaste);

    return () => {
      input.removeEventListener('keydown', onKeyDown);
      input.removeEventListener('paste', onPaste);
    };
  }, []);

  const delimiters = [KeyCodes.comma, KeyCodes.enter];
  const animatedSelectComponents = makeAnimated();
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState<any>({
    grupoEconomico: [],
    canaisResponsaveis: [],
    emails: [],
    cnpjRaiz: [],
  });

  const isFormValid = () => {
    const requiredFields = ['cnpjRaiz', 'emails', 'grupoEconomico'];
    return requiredFields.every(field => formData[field].length > 0);
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

  const fullNameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:\s+[A-Za-zÀ-ÖØ-öø-ÿ]+)+$/;

  const isFormValidDealer = () => {
    return (
      fullNameRegex.test(formDataDealer.nome.trim()) &&
      emailRegex.test(formDataDealer.email.trim()) &&
      !!formDataDealer.profile?.value
    );
  };
  useEffect(() => {
    return () => {
      setFormData(initialFormState);
      setSendData(false);
    };
  }, []);

  const handleCancel = () => {
    onCancel();
    setFormDataDealer(initialFormStateDealer);
  };

  const handlePostDealer = async (formData: any) => {
    if (type === 'newDealer') {
      let loggedUserEmail: unknown;

      try {
        const currentUser = JSON.parse(
          localStorage.getItem('currentUser') || '{}',
        );
        loggedUserEmail = currentUser?.userEmail;
      } catch {
        loggedUserEmail = undefined;
      }

      const loggedUserDomain =
        typeof loggedUserEmail === 'string' &&
        emailRegex.test(loggedUserEmail.trim())
          ? loggedUserEmail.trim().split('@')[1].toLowerCase()
          : null;
      const dealerDomain = formDataDealer.email
        .trim()
        .split('@')[1]
        ?.toLowerCase();

      if (!loggedUserDomain || dealerDomain !== loggedUserDomain) {
        toast.error('O e-mail precisa ser do mesmo domínio da revenda.');
        return;
      }
    }

    setIsSaving(true);
    const payload = {
      funcionarioNome: formDataDealer.nome,
      funcionarioEmail: formDataDealer.email,
      representanteLogadoEmail: '',
      perfilDescricao: formDataDealer.profile.descricao,
    };
    try {
      if (type === 'newDealer') {
        const response = await updateDealer(false, payload);
        toast.success('Novo colaborador cadastrado com sucesso!');

        handleCancel();
      } else {
        const response = await updateDealer(true, payload);
        toast.success('colaborador editado com sucesso!');
        handleCancel();
      }
      getListDealers?.();
    } catch (error: any) {
      console.error(error);

      toast.error(
        error?.response?.data?.errors?.[0] ||
          'Ocorreu um erro ao salvar o colaborador.',
      );
    } finally {
      setIsSaving(false);
    }
  };

  const [sendData, setSendData] = useState<any>(false);
  const [{ reject, isLoading }, consultingCnpj] = useClient();
  const { isLoadingAPICall, error, registerFinalClient, handleAPIError } =
    useAccess();
  const [{ responsibleChannel }, , , , , , fetchResponsibleChannel] =
    usePermissions();

  const [ctrlError, setCtrlError] = useState<boolean>(false);

  const handleAdditionCnpj = async (tag: any) => {
    const cnpjText = tag.text.replace(/[./-]/g, '').toUpperCase();
    const formattedCnpj = formatDocumentCNPJ(cnpjText);

    const newCnpj = {
      id: tag.id,
      text: formattedCnpj,
    };

    const responseConsulted = await consultingCnpj(cnpjText);
    const grupoEconomico = responseConsulted?.cliente?.grupoEconomico || '';

    if (grupoEconomico && !formData.grupoEconomico.includes(grupoEconomico)) {
      setFormData({
        ...formData,
        cnpjRaiz: [...formData.cnpjRaiz, newCnpj],
        grupoEconomico: [...formData.grupoEconomico, grupoEconomico],
      });
    }
  };

  const handleDeleteCnpj = (index: number) => {
    const newCnpjList = [...formData.cnpjRaiz];
    const newGrupoEconomicoList = [...formData.grupoEconomico];

    newCnpjList.splice(index, 1);

    if (index < newGrupoEconomicoList.length) {
      newGrupoEconomicoList.splice(index, 1);
    }

    setFormData({
      ...formData,
      cnpjRaiz: newCnpjList,
      grupoEconomico: newGrupoEconomicoList,
    });
  };

  const handleResponsibleChannelChange = (canais: any) => {
    setFormData({ ...formData, canaisResponsaveis: canais });
  };

  const handleAdditionEmail = (email: ReactTag) => {
    setFormData({
      ...formData,
      emails: [...formData.emails, email],
    });
  };

  const handleDragEmail = (
    email: ReactTag,
    currPos: number,
    newPos: number,
  ) => {
    const newEmails = formData.emails.slice();

    newEmails.splice(currPos, 1);
    newEmails.splice(newPos, 0, email);

    setFormData({
      ...formData,
      emails: newEmails,
    });
  };

  const handleCnpjsDrag = (_tag: ReactTag, currPos: number, newPos: number) => {
    const newCNPJS = [...formData.cnpjRaiz];
    const [movedCNPJ] = newCNPJS.splice(currPos, 1);
    newCNPJS.splice(newPos, 0, movedCNPJ);

    const newgrupoEconomico = [...formData.grupoEconomico];

    const currentGrupo = newgrupoEconomico[currPos];

    newgrupoEconomico.splice(currPos, 1);
    newgrupoEconomico.splice(newPos, 0, currentGrupo);

    setFormData({
      ...formData,
      cnpjRaiz: newCNPJS,
      grupoEconomico: newgrupoEconomico,
    });
  };
  const handleDeleteEmail = (i: any) => {
    setFormData({
      ...formData,
      emails: formData.emails.filter((email: any, index: any) => index !== i),
    });
  };

  const handleRegisterForm = async () => {
    const information = {
      ...formData,
      cnpjRaiz: formData.cnpjRaiz.map((cnpj: any) =>
        cnpj.text.replace(/[.\-/]/g, ''),
      ),
      emails: formData.emails.map((email: Partial<any>) => email.id),
    };

    const success: boolean = await registerFinalClient(information);

    if (success) {
      sendNotification('Cliente cadastrado com sucesso.', toastConfig);
      handleCancel();
    } else {
      setCtrlError(true);
    }
  };

  const handleEmailInputBlur = (value: string) => {
    const trimmedValue = value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (trimmedValue && emailRegex.test(trimmedValue)) {
      const newEmail = {
        id: trimmedValue,
        text: trimmedValue,
        className: '',
      };
      if (!formData.emails.some((email: any) => email.text === trimmedValue)) {
        handleAdditionEmail(newEmail);
      }
    }
  };

  useEffect(() => {
    fetchResponsibleChannel();
    if (type == 'newDealer') {
      setFormDataDealer(initialFormStateDealer);
    }
  }, []);

  const renderGrupoEconomico = () => {
    const { grupoEconomico } = formData;

    if (grupoEconomico.length === 0) {
      return '-';
    }

    const primary = grupoEconomico[0];
    const others = grupoEconomico.slice(1);

    return (
      <S.ListInline>
        <ul>
          <li>
            <span>Principal </span> {primary}
          </li>
          {others.length > 0 && (
            <li className="same">
              <span>Outros </span> {others.join(', ')}
            </li>
          )}
        </ul>
      </S.ListInline>
    );
  };

  return typeLayout !== 'editDealer' && typeLayout !== 'newDealer' ? (
    <S.ClientRegistrationForm>
      {sendData === false ? (
        <>
          <S.Text>
            Preencha as informações abaixo para realizar o cadastro.
          </S.Text>

          <S.FormControl style={{ paddingBottom: 0 }}>
            <S.Text className="bold no-margin small">CNPJ Raiz</S.Text>
            <S.Text className="small" style={{ fontSize: '10px' }}>
              Digite o CNPJ e pressione a tecla Enter para buscar os dados.
            </S.Text>

            <div ref={cnpjContainerRef}>
              <ReactTags
                classNames={{ tags: 'ReactTags__tags secondary' }}
                tags={formData.cnpjRaiz}
                handleAddition={handleAdditionCnpj}
                handleDelete={handleDeleteCnpj}
                handleDrag={handleCnpjsDrag}
                delimiters={[188, 13]}
                placeholder="Digite aqui os cnpjs..."
              />
            </div>
            {isLoading && (
              <S.Text
                className="small"
                style={{ marginTop: '5px', fontSize: '12px' }}
              >
                Buscando CNPJ...
              </S.Text>
            )}
          </S.FormControl>

          {reject && <S.Text className="small-danger">{reject}</S.Text>}

          <>
            <S.FormControl style={{ paddingTop: 10 }}>
              <S.Text className="bold no-margin small flexing">
                Grupos econômicos
                <Tooltip content="O grupo econômico principal é determinado a partir do primeiro CNPJ raiz informado.">
                  <FaRegCircleQuestion
                    style={{
                      width: '1.1em',
                      height: '1.1em',
                      marginLeft: '5px',
                      color: 'gray',
                    }}
                  />
                </Tooltip>
              </S.Text>
              <div style={{ paddingTop: 5 }}>{renderGrupoEconomico()} </div>
            </S.FormControl>

            <S.FormControl>
              <S.Text className="bold no-margin small">
                E-mail(s) para acesso
              </S.Text>
              <ReactTags
                classNames={{ tags: 'ReactTags__tags secondary' }}
                tags={formData.emails}
                inline={false}
                handleDelete={handleDeleteEmail}
                handleAddition={handleAdditionEmail}
                handleDrag={handleDragEmail}
                delimiters={delimiters}
                placeholder="Digite aqui os emails..."
                autofocus={false}
                inputFieldPosition="inline"
                autocomplete
                handleInputBlur={handleEmailInputBlur}
              />
            </S.FormControl>

            <S.FormControl>
              <S.Text className="bold no-margin small">
                Canais Responsáveis (opcional)
              </S.Text>
              <S.CustomMultiSelect
                classNamePrefix={'Select'}
                className="secondary"
                components={animatedSelectComponents}
                isMulti
                options={responsibleChannel}
                value={formData.canaisResponsaveis}
                onChange={handleResponsibleChannelChange}
                placeholder="Selecione os canais responsáveis"
                isClearable
              />
            </S.FormControl>

            <S.Buttons>
              <S.IconButton
                type="button"
                className="text"
                onClick={handleCancel}
              >
                Cancelar
              </S.IconButton>
              <S.IconButton
                type="button"
                className={`success ${isFormValid() ? '' : 'disabled'}`}
                onClick={() => {
                  if (isFormValid()) {
                    setSendData(formData);
                    setCtrlError(false);
                  }
                }}
                disabled={!isFormValid()}
              >
                Cadastrar
              </S.IconButton>
            </S.Buttons>
          </>
        </>
      ) : (
        <>
          <S.Text>
            Você está finalizando o cadastro. Confira se as informações foram
            preenchidas corretamente e se tudo estiver correto, prossiga.
          </S.Text>
          <S.Featured className="background margin-bottom">
            {[
              {
                label: 'CNPJ Raiz',
                value: formData?.cnpjRaiz
                  .map((cnpj: any) => cnpj.text ?? cnpj)
                  .join(', '),
              },
              {
                label: 'Grupo econômico',
                value: renderGrupoEconomico(),
              },
              {
                label: 'E-mails para acesso',
                value: formData?.emails
                  .map((email: any) => email.text ?? email)
                  .join(', '),
              },
              {
                label: 'Canais Responsáveis',
                value: formData?.canaisResponsaveis?.length
                  ? formData?.canaisResponsaveis
                      .map((area: any) => area.label ?? area)
                      .join(', ')
                  : '-',
              },
            ].map((item, index) => (
              <React.Fragment key={index}>
                {item.value !== undefined && (
                  <>
                    <S.Text className="bold top-margin">{item.label}</S.Text>
                    <S.Text>{item.value ?? '-'}</S.Text>
                  </>
                )}
              </React.Fragment>
            ))}
          </S.Featured>
          {error && ctrlError === true && (
            <S.Text className="small-danger top-margin">{error}</S.Text>
          )}
          <S.Buttons>
            <S.IconButton
              type="submit"
              className="text"
              onClick={() => {
                setSendData(false);
              }}
            >
              Voltar
            </S.IconButton>
            <S.IconButton
              type="button"
              className="success"
              onClick={handleRegisterForm}
            >
              {isLoadingAPICall ? <LoadingCircle /> : 'Confirmar'}
            </S.IconButton>
          </S.Buttons>
        </>
      )}
    </S.ClientRegistrationForm>
  ) : (
    <S.ClientRegistrationForm className="dialog-dealer">
      <>
        <S.Text>Preencha os dados do usuário:</S.Text>

        {/* NOME */}
        <S.FormControl>
          <S.Text className="bold no-margin small">Nome</S.Text>

          <S.Input
            type="text"
            maxLength={50}
            placeholder="Digite o nome do colaborador"
            value={formDataDealer.nome}
            onChange={e =>
              setFormDataDealer(prev => ({
                ...prev,
                nome: e.target.value,
              }))
            }
          />
        </S.FormControl>

        {/* EMAIL */}
        <S.FormControl className={type == 'newDealer' ? '' : 'disabled-email'}>
          <S.Text className="bold no-margin small">E-mail</S.Text>

          <S.Input
            disabled={type == 'newDealer' ? false : true}
            type="email"
            className={type == 'newDealer' ? '' : 'disabled'}
            value={formDataDealer.email}
            onChange={e =>
              setFormDataDealer(prev => ({
                ...prev,
                email: e.target.value,
              }))
            }
            placeholder="Digite o email do colaborador"
          />
        </S.FormControl>

        {/* PERFIL */}
        <S.FormControl>
          <S.Text className="bold no-margin small">Perfil de acesso</S.Text>

          <S.CustomMultiSelect
            onMenuOpen={() => setMenuOpen(true)}
            onMenuClose={() => setMenuOpen(false)}
            classNamePrefix="Select"
            className="secondary"
            isMulti={false}
            options={accessProfiles}
            value={formDataDealer.profile}
            placeholder="Selecione o perfil"
            onChange={selectedOption => {
              setFormDataDealer(prev => ({
                ...prev,
                profile: selectedOption as AccessProfile | null,
              }));
            }}
          />
        </S.FormControl>

        {/* BOTÕES */}
        <S.Buttons>
          <S.IconButton type="button" className="text" onClick={handleCancel}>
            Cancelar
          </S.IconButton>

          <S.IconButton
            type="button"
            className={`success ${isFormValidDealer() ? '' : 'disabled'}`}
            onClick={() => {
              setSendData(formData);
              handlePostDealer(formDataDealer);
            }}
            disabled={!isFormValidDealer()}
          >
            {typeLayout === 'editDealer' ? 'Editar' : 'Cadastrar'}
          </S.IconButton>
        </S.Buttons>
      </>
    </S.ClientRegistrationForm>
  );
};
